import './scss/main.scss';
'use strict';

/* Global Variables and Functions */
const ajaxUrl = '/wp-admin/admin-ajax.php';

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

/* JS Start when Document Load & DOM build*/
document.addEventListener('DOMContentLoaded', ready);
function ready() {

    /* Header Fixed */
    const scrollUpButton = document.querySelector('.js-scroll-up');
    const siteHeader = document.querySelector('.site-header');
    let siteHeaderHeight = 0;
    let headingSectionHeight = 0;

    if (siteHeader && scrollUpButton) {
        headingSectionHeight = siteHeader.offsetHeight;

        const headerPosition = () => {
            if (window.scrollY >= headingSectionHeight) {
                scrollUpButton.classList.add('show');
            } else {
                scrollUpButton.classList.remove('show');
            }
        }

        headerPosition();

        document.addEventListener('scroll', function () {
            headerPosition();
        });

    }

    if (siteHeader) {
        // Set --lx-header-height var
        siteHeaderHeight = siteHeader.clientHeight;
        document.documentElement.style.setProperty("--header-height", `${siteHeaderHeight}px`);

        window.addEventListener("resize", () => {
            siteHeaderHeight = siteHeader.clientHeight;
            document.documentElement.style.setProperty("--header-height", `${siteHeaderHeight}px`);
        });
    }

    function onResize() {
        // Get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty("--vh", `${vh}px`);

        let scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty("--scroll-bar-width", `${scrollBarWidth}px`);

        // Listen to the resize event
        window.addEventListener("resize", () => {
            // Execute the same script as before
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);

            scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.documentElement.style.setProperty("--scroll-bar-width", `${scrollBarWidth}px`);
        });
    }

    onResize();
}

/* ==========================================================================
* jQuery Scripts
* ========================================================================== */
(function($){
    $(document).ready(function() {

        /* Burger Menu Action */
        $('.js-burger').on('click', function () {
            $(this).toggleClass('active');
            $('.header__menu-wrapper').toggleClass('active');
            $('body').toggleClass('menu-open');
        });

        $('.page-overlay').on('click', function () {
            $('.js-burger').trigger('click');
        });

        /* Scroll Up */
        $('.js-scroll-up').on('click', function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

        /* Scroll To Section */
        $('.js-anchor').on('click', function (e) {
            e.preventDefault();
            const anchorSection = $(this).attr('href');
            $('html, body').animate({ scrollTop: $(anchorSection).offset().top - 80}, 500, 'linear');
        });

        /* Open Newsletter Form */
        $('.js-newsletter-link a').on('click', function(e) {
            e.preventDefault();
            $(this).closest('header').find($('.js-newsletter-form')).toggleClass('active');
            $(this).closest('footer').find($('.js-newsletter-form')).toggleClass('active');
        });

        $('header #forminator-module-84, footer #forminator-module-84').on('forminator:form:submit:success', function (e, formData) {
           const timeout1 = setTimeout(() => {
               $(this).closest('.js-newsletter-form').removeClass('active');

                clearTimeout(timeout1)
            }, 5000)

        });

        // Drag shapes
        let zIndex = 1

        const shapeOptions = {
            start: function(event, ui) {
                $(this).css('z-index', zIndex++);
                // $('.site-content').css('z-index', 9999);
            },
            // stop: function(event, ui) {
            //     $('.site-content').css('z-index', 1);
            // }
        }

        $( "#draggable-circle" ).draggable(shapeOptions);
        $( "#draggable-triangle" ).draggable(shapeOptions);
        $( "#draggable-rectangle" ).draggable(shapeOptions);

        $('.js-shapes img').on('click touchstart', function () {
            $(this).css({'z-index': zIndex++});
        })

        // Sticky CTA Button
        function checkOffset() {
            const container = $('.js-cta-container');
            const button = $('.js-cta');

            if (window.scrollY < $(container).offset().top + $(container).outerHeight(true) - $(button).outerHeight(true) - window.outerHeight) {
                button.addClass('sticky');

            } else {
                button.removeClass('sticky');
            }
        }
        // $(window).load(checkOffset);
        checkOffset();
        $(document).scroll(checkOffset);
        $(window).resize(checkOffset);
    });
})(jQuery, window);